import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-payment-fail',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './payment-fail.html',
  styleUrls: ['./payment-fail.scss']
})
export class PaymentFail {

  constructor(public languageService: LanguageService) {}

  t(key: string): string {
    return this.languageService.translate(key);
  }
}
